/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalEditIdentityProps } from '../../types';
import ModalExecuteAction from './ModalExecuteAction';
import { useEffect, useState } from 'react';
import { Alert, Input } from '@piggytechng/component-library';
import { OverideInputStyle } from '../../helpers/utils';
import useCustomers from '../../hooks/useCustomers';

const IDENTITY_LENGTH = 11;

function ModalEditIdentity({
  modalIsOpen,
  setIsOpen,
  type,
  currentValue = '',
  actionColor = '#1734ca',
}: ModalEditIdentityProps) {
  const [value, setValue] = useState('');
  const [showExecuteAction, setShowExecuteAction] = useState(false);
  const { updateUserIdentity, isRunningUserAction } = useCustomers();

  const label = type.toUpperCase();

  useEffect(() => {
    if (modalIsOpen) setValue(currentValue.replace(/\D/g, '').slice(0, IDENTITY_LENGTH));
  }, [modalIsOpen, currentValue]);

  const isValid = value.length === IDENTITY_LENGTH;
  const isUnchanged = value === currentValue;

  const closeAll = () => {
    setShowExecuteAction(false);
    setIsOpen(false);
    setValue('');
  };

  const onContinue = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (!isValid) {
      Alert.error(`${label} must be exactly ${IDENTITY_LENGTH} digits`);
      return;
    }
    if (isUnchanged) {
      Alert.error(`Enter a ${label} different from the current one`);
      return;
    }
    setIsOpen(false);
    setShowExecuteAction(true);
  };

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <div className={`modal-base general success action modal-action flex--4`}>
          <span onClick={closeAll}>&times;</span>
          <form style={{ display: 'flex', flexDirection: 'column', gap: '20px' }} action="" onSubmit={onContinue}>
            <h4>Edit {label}</h4>

            <Input
              {...OverideInputStyle}
              label={label}
              id={`identity-${type}`}
              name={`identity-${type}`}
              className="user-form-input"
              placeholder={`Enter the ${IDENTITY_LENGTH}-digit ${label}`}
              onChange={(e) => setValue(e.target.value.replace(/\D/g, '').slice(0, IDENTITY_LENGTH))}
              value={value}
            />

            <div className="button-cont flex--2">
              <button type="button" onClick={closeAll}>
                Cancel
              </button>
              <button
                type="submit"
                onClick={onContinue}
                style={{ backgroundColor: actionColor }}
                disabled={!isValid || isUnchanged}
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showExecuteAction}
        setIsOpen={setShowExecuteAction}
        isLoading={isRunningUserAction}
        actionColor={actionColor}
        text={`change this customer's ${label} to ${value}?`}
        action={(password: string) => updateUserIdentity(type, value, password, closeAll)}
      />
    </>
  );
}

export default ModalEditIdentity;
